import { createQueryActions } from 'helpers/store/createQueryActions';

export const getDocuments = createQueryActions('getDocuments');

export const getDocument = createQueryActions('getDocument');

export const uploadDocument = createQueryActions('uploadDocument');

export const deleteDocument = createQueryActions('deleteDocument');
